import { 
    SET_MODULE_NAME, 
    SET_CATEGORY_NAME, 
    SET_SEARCH_VALUE, 
    SET_FILTER_VALUE, 
    SET_TYPE_VALUE, 
    SET_TAB_POSITION,
    SET_TAB_MNUCODE
} from "../Action/AppAction";


const initialState = {
    module: '',
    search: '',
    filter: '',
    category: '',
    asset_type: '',
    tabPosition: 1,
    tabMenuCode: 'function.function_code:GeneralAssets'
}

const AppReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MODULE_NAME:
            return { ...state, module: action.name };
        case SET_CATEGORY_NAME:
            return { ...state, category: action.name };
        case SET_SEARCH_VALUE:
            return { ...state, search: action.value };
        case SET_FILTER_VALUE:
            return { ...state, filter: action.value };
        case SET_TYPE_VALUE:
            return { ...state, asset_type: action.value };
        case SET_TAB_POSITION:
            return { ...state, tabPosition: action.position }; 
        case SET_TAB_MNUCODE:
            return { ...state, tabMenuCode: action.menu }; 
        default:
            return state;
    }
}

export default AppReducer;